/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAttributeDataSourcePathParams = NonNullable<
  operations['patchAttributeDataSource']['parameters']['path']
>;

export type PatchAttributeDataSourceRequestBody = OperationRequestBodyContent<operations['patchAttributeDataSource']>;

export interface Input extends PatchAttributeDataSourcePathParams {
  apiVersion?: string;
  body: PatchAttributeDataSourceRequestBody;
}

export async function patchAttributeDataSource(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/attribute-data-sources/{dataSourceKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
